import React, {Component} from 'react';
import {Select} from 'antd';

const {Option} = Select;

/**
 * creat by tianruojun
 * 选部门组件（树形）
 * @description 一个用来选部门的弹窗组件，可以设置回显和返回选择的部门
 * @class TreeModuleBySelectDept
 * @extends {Component}
 */
export default class SelectWithText extends Component {
    componentWillMount() {
        if (this.props.defaultValue != undefined) {
            this.props.onChange(this.props.defaultValue);
        }
    }

    render() {

        let {
            placeholder,
            onChange,
            value,
            selectValues,
            defaultValue,
            style = {},
            labelName,
            showIcon = false
        } = this.props;

        return (
            <div style={{display: "flex", alignItems: "center"}} className={"selectWithText"}>
                <div>{labelName}：</div>
                <Select placeholder={placeholder} defaultValue={defaultValue} value={value}
                        style={{width: 120, ...style}} onChange={(val) => {
                    onChange(val)
                }}>
                    {
                        selectValues.map((item, index) => {
                            return <Option key={index} value={item.key}>{(showIcon && item.id) ? <img src={item.logo}
                                                                                                      style={{
                                                                                                          width: 15,
                                                                                                          height: 15,
                                                                                                          objectFit: "cover",
                                                                                                          marginRight: 5
                                                                                                      }}/> : null}{item.name}</Option>
                        })
                    }
                </Select>
                <style>{`
                    .selectWithText .ant-select-selection{border: 1px solid #eef2fb; background-color: #f5f8fc;}
                `}</style>
            </div>
        )
    }

}